import type { Supplier } from "./types";

/**
 * ⚠️ MOCK 資料層 —— 配對／推薦皆為前端模擬，尚無後端 API。
 * 待後端提供 endpoint 後，將下方 mockMatchByPhone / mockMatchByAddress
 * 換成 handleRequest({ asyncRequest: () => api.post(...) }) 即可，UI 不需改。
 */

/** 手機 → 命中的既有客戶瓦斯行（demo：0912345678 命中）。 */
export const MAPPING_DB: Record<string, Supplier> = {
  "0912345678": { id: "S001", company: "台中瓦斯行", area: "台中市西區", confidence: 0.92 },
};

/** 推薦池（依距離排序，僅含距離資訊）。 */
export const RECOMMENDATION_POOL: Supplier[] = [
  { id: "S010", company: "西屯陽光瓦斯行", area: "台中市西屯區", distance: "1.2 km", tags: ["✓ 平台合作店", "24h 配送"] },
  { id: "S011", company: "福星快配瓦斯", area: "台中市西屯區", distance: "1.8 km", tags: ["✓ 平台合作店"] },
  { id: "S012", company: "好鄰居瓦斯行", area: "台中市西屯區", distance: "2.5 km", tags: ["✓ 平台合作店"] },
  { id: "S013", company: "瓦斯到家", area: "台中市西區", distance: "3.1 km", tags: ["✓ 平台合作店"] },
  { id: "S014", company: "城市瓦斯配送", area: "台中市北區", distance: "3.8 km", tags: ["✓ 平台合作店"] },
];

/** 推薦最多輪替家數。 */
export const MAX_RECOMMEND = RECOMMENDATION_POOL.length;

/** 模擬非同步延遲。 */
const delay = (ms: number) => new Promise<void>((r) => setTimeout(r, ms));

/**
 * 依手機配對既有客戶。於 OTP 驗證成功後同步呼叫（沿用全域 loading，無雷達過場），
 * 故延遲較短。TODO(api): 換成後端「以手機查既有客戶綁定」endpoint。
 */
export const mockMatchByPhone = async (phone: string): Promise<Supplier | null> => {
  await delay(500);
  const cleaned = phone.replace(/\D/g, "");
  return MAPPING_DB[cleaned] ?? null;
};

/**
 * 依地址配對推薦或候補。
 * demo 規則：手機末碼為 0 → 該區暫無合作瓦斯行（候補）；否則進推薦池。
 * TODO(api): 換成後端「以地址查附近合作瓦斯行」endpoint。
 */
export const mockMatchByAddress = async (
  phone: string,
): Promise<{ type: "recommend" | "waitlist" }> => {
  await delay(2600);
  const cleaned = phone.replace(/\D/g, "");
  return { type: cleaned.endsWith("0") ? "waitlist" : "recommend" };
};

/**
 * 送出線上簽約（mock）。forceFail=true 時模擬「簽名交易生成失敗」，用來示範重簽流程。
 * TODO(api): 換成後端簽約 endpoint，成敗改由回應決定。
 */
export const mockSubmitContract = async (forceFail = false): Promise<{ ok: boolean; reason?: string }> => {
  await delay(1200);
  if (forceFail) return { ok: false, reason: "簽名交易生成失敗" };
  return { ok: true };
};
